export class HistoryTicket {

    id: number;
    timestamp: string;
    bingoGameId: number;
    status: string;
    numbers: number[];
    stake: number;
    wonAmount: number;
    jackpotWonAmount: number;
    amountOfRounds: number;
    disbursed: boolean;
    calculated: boolean;
    code: number;
    number: number;
    storno: boolean;
    jackpotCode: string;

    constructor(id: number, timestamp: string, bingoGameId: number, status: string, numbers: number[], stake: number,
        wonAmount: number, jackpotWonAmount: number, amountOfRounds: number, disbursed: boolean, calculated: boolean,
        code: number, number: number, storno: boolean, jackpotCode: string) {
        this.id = id;
        this.timestamp = timestamp;
        this.bingoGameId = bingoGameId;
        this.status = status;
        this.numbers = numbers;
        this.stake = stake;
        this.wonAmount = wonAmount;
        this.jackpotWonAmount = jackpotWonAmount;
        this.amountOfRounds = amountOfRounds;
        this.disbursed = disbursed;
        this.calculated = calculated;
        this.code = code;
        this.number = number;
        this.storno = storno;
        this.jackpotCode = jackpotCode;
    }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/history-ticket.ts